import React, { useEffect } from 'react'

/**
 * Componente StatusCode para establecer el código de estado HTTP en las páginas
 * Útil para indicar a los rastreadores el estado de la página (200, 404, etc.)
 *
 * @param {Object} props - Propiedades del componente
 * @param {number} props.code - Código de estado HTTP (200, 404, etc.)
 * @returns {null} - Este componente no renderiza nada visible
 */
const StatusCode = ({ code }) => {
  useEffect(() => {
    // Verificar que estamos en el navegador
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Crear o actualizar la meta etiqueta para el código de estado
      let meta = document.querySelector('meta[name="prerender-status-code"]')

      if (!meta) {
        meta = document.createElement('meta')
        meta.name = 'prerender-status-code'
        document.head.appendChild(meta)
      }

      meta.content = code.toString()

      // Para Vercel y otros servicios que utilizan esta meta etiqueta
      let metaVercel = document.querySelector('meta[name="http-status"]')

      if (!metaVercel) {
        metaVercel = document.createElement('meta')
        metaVercel.name = 'http-status'
        document.head.appendChild(metaVercel)
      }

      metaVercel.content = code.toString()

      // Limpiar al desmontar el componente
      return () => {
        if (meta && meta.parentNode) {
          meta.parentNode.removeChild(meta)
        }
        if (metaVercel && metaVercel.parentNode) {
          metaVercel.parentNode.removeChild(metaVercel)
        }
      }
    }
  }, [code])

  // Este componente no renderiza nada visible
  return null
}

export default StatusCode
